import { updateAction } from './utils';
export const SsoActionTypes = {
  SET_SSO_DATA: 'SET_SSO_DATA',
  RESET_STATE: 'RESET_STATE'
};
export const setSsoData = updateAction(SsoActionTypes.SET_SSO_DATA);